import * as React from 'react';
import Svg, { SvgProps, G, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={24} height={24} {...props}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M13.789 1.578l9.764 19.528A2 2 0 0121.763 24H2.237a2 2 0 01-1.789-2.894l9.764-19.528a2 2 0 013.578 0z"
          fill="#FF9500"
        />
        <Path
          d="M10.7 6h2.7l-.5 10.18h-1.7L10.7 6zm1.34 11.26c.44 0 .82.14 1.12.42.28.28.44.64.44 1.08 0 .44-.16.82-.44 1.1-.32.28-.68.42-1.12.42-.44 0-.8-.16-1.08-.44-.32-.28-.46-.64-.46-1.08 0-.44.14-.8.46-1.08.28-.28.64-.42 1.08-.42z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
}

const WarningIcon = React.memo(SvgComponent);
export default WarningIcon;
